import React from "react"
import LocationModal from "../../Common/FilterModal/Location"
import CategoryModal from "../../Common/FilterModal/Category"
import CategoryList from "../../Common/CategoryList"
import Loader from "../../Common/Loader"
import Icon from "../../Utils/Icon"

import * as styles from "./../Styles/Filter.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import title1x from "../../../images/title_mobile@1x.png"
import title2x from "../../../images/title_mobile@2x.png"
import title3x from "../../../images/title_mobile@3x.png"

const INITIAL_AREA_TITLE = "エリアを選ぶ"

const SP = (props) => {
  return (
    <React.Fragment>
      <div className={styles.background}>
        <div>
          <img
            className={styles.mv}
            src={title2x}
            srcSet={`${title1x} 320w, ${title2x} 640w, ${title3x} 960w`}
          />
        </div>
        <div className={styles.outer}>
          <div className={styles.outerTitle}>お店・施設の混雑情報</div>
          <div className={styles.inner}>
            <div className={styles.header}>
              <div className={styles.currentLocation}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    props.setShowLocationModal(true)
                  }}
                >
                  <div>
                    <Icon type="feather" name="map-pin" />
                    <span
                      className={cn(
                        "currentLocationText",
                        props.locationText === INITIAL_AREA_TITLE
                          ? "initialLocationText"
                          : ""
                      )}
                    >
                      {props.locationText}
                    </span>
                    {!props.componentDisabled && (
                      <Icon
                        className={styles.chevron}
                        type="feather"
                        name="chevron-down"
                      />
                    )}
                  </div>
                </a>
              </div>
            </div>
            <div className={styles.hr}>
              <hr className="common-hr" />
            </div>
            <div className={styles.categoryList}>
              <CategoryList
                {...props}
                layered={false}
                categories={props.featuredCategories}
                onChange={props.handleCategory}
              />
            </div>
          </div>
          <div>
            <a
              className={styles.buttonLink}
              href="#"
              onClick={(e) => {
                e.preventDefault()
                if (!props.componentDisabled) {
                  props.onSubmit(props.city, props.prefecture, props.category)
                }
              }}
            >
              <div
                className={cn(
                  "searchButton",
                  props.componentDisabled ? "searchButton--disabled" : ""
                )}
              >
                <Loader show={props.showLoader} color="white" small={true} />
                {!props.showLoader && <span>この条件でさがす</span>}
              </div>
            </a>
          </div>
        </div>
      </div>
      <LocationModal
        {...props}
        show={props.showLocationModal}
        onHide={() => props.setShowLocationModal(false)}
        onChange={props.handleLocation}
      />
      <CategoryModal
        {...props}
        show={props.showCategoryModal}
        onHide={() => props.setShowCategoryModal(false)}
        onChange={props.handleCategory}
      />
    </React.Fragment>
  )
}
export default SP
